import React, { Fragment, PureComponent } from 'react';
import { Pagination } from '~/Api/Pagination';
import { formatCondensedHumanMonth } from '~/DateTime';
import { BrandsQuery, Record } from '~/MedicinalBrandsAnalytics/VirtualBrand/History';
import HistoryIcon from '~/MedicinalBrandsAnalytics/VirtualBrand/HistoryIcon';
import HistorySentence from '~/MedicinalBrandsAnalytics/VirtualBrand/HistorySentence';
import ActivityIndicator from '~/UI/ActivityIndicator';
import Icon from '~/UI/Icon';
import SimplePaginator from '~/UI/SimplePaginator';

import styles from './styles.less';

interface Props {
	query: BrandsQuery;
	history: Record[] | null;
	pagination: Pagination | null;
	isFetching: boolean;
	onLoad(brandsQuery: BrandsQuery): void;
	onUnload(brandsQuery: BrandsQuery): void;
	onClose(): void;
}

export default class HistoryPanel extends PureComponent<Props> {
	componentDidMount() {
		const { query, onLoad } = this.props;
		onLoad(query);
	}

	componentDidUpdate(prevProps: Props) {
		const { query, onLoad, onUnload } = this.props;

		if (!prevProps.query.equals(query)) {
			onUnload(prevProps.query);
			onLoad(query);
		}
	}

	componentWillUnmount() {
		const { query, onUnload } = this.props;
		onUnload(query);
	}

	renderTitle(index: number, yearMonth: Date, previousMonth: Date) {
		if (index === 0) {
			return <h2 className={styles.h2}>Latest news</h2>;
		}
		if (yearMonth.getFullYear() === previousMonth.getFullYear() && yearMonth.getMonth() === previousMonth.getMonth()) {
			return <h2 className={styles.h2}>Last month</h2>;
		}
		return <h2 className={styles.h2}>{formatCondensedHumanMonth(yearMonth)}</h2>;
	}

	render() {
		const { query, history, pagination, isFetching, onLoad, onClose } = this.props;

		const previousMonth = new Date();
		previousMonth.setMonth(previousMonth.getMonth() - 1);

		let previousYearMonth: Date | null = null;

		return (
			<Fragment>
				<div className={styles.overlay} />

				<div className={styles.container}>
					<div className={styles.close} onClick={onClose}>
						<Icon name='close-dark' />
					</div>

					<h1 className={styles.h1}>News</h1>

					{history?.map((record, i) => {
						const { yearMonth } = record;
						const isAnotherMonth =
							!previousYearMonth ||
							previousYearMonth.getFullYear() !== yearMonth.getFullYear() ||
							previousYearMonth.getMonth() !== yearMonth.getMonth();

						previousYearMonth = yearMonth;

						return (
							<Fragment key={record.hash}>
								{isAnotherMonth ? this.renderTitle(i, yearMonth, previousMonth) : null}

								<div className={styles.newsItem}>
									<HistoryIcon record={record} />
									<p className={styles.newsItemP}>
										<HistorySentence sentence={record.summary} />
									</p>
								</div>
							</Fragment>
						);
					})}

					{isFetching ? (
						<ActivityIndicator />
					) : pagination && pagination.hasNextPage() ? (
						<SimplePaginator count={pagination.perPage} onLoadMore={() => onLoad(query)} />
					) : null}
				</div>
			</Fragment>
		);
	}
}
